import { render } from "./NewsFeedNavigation.vue?vue&type=template&id=54c63610"
import script from "./NewsFeedNavigation.vue?vue&type=script&lang=js"
export * from "./NewsFeedNavigation.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__